<template lang="pug">
	.check-box
		.check-box-container(
			:class='{ bubbled : options.bubbled }'

			@click='checked'
		)
			p.label {{ options.title }}
			p.desc(v-if='options.text') {{ options.text }}
			.check(
				:class = '{ checked : checkedState }'
				:tabindex='lastTabIndex'
				@keydown.enter='checked'
			)
</template>

<script>
export default {
	name : 'check-box',

	props : {
		options : {
			type : [Array, Object],
		},

		value : {
			type : Boolean,
		},

		errors : {
			type : [Object, String, Boolean],
		},

		formValue : {
			type : Object,
		},

		field : {
			type : Object,
		},

		form : {
			type : Object,
		},

		lastTabIndex : {
			type : Number,
		}

	},

	data : () => ( {
		checkedState : false,
	} ),

	created() {

		if ( this.value ) {
			this.checkedState = this.value;
		}
	},

	methods : {

		checked() {

			// the reason why we have to do it like this
			// is due to the fact that you're unable to
			// customize the input tag when it has the type
			// checkbox
			if ( this.checkedState ) {
				this.checkedState = false;
				return;
			}

			this.checkedState = true;
		},

	},

	watch : {

		checkedState( val ) {
			this.$emit( 'input', val );
		}

	}
};
</script>

<style lang="scss">
.check-box {
	cursor: pointer;
	height: 100%;
	max-height: 57px;

	.check-box-container {
		display: flex;
		flex-flow: row-reverse nowrap;
		align-items: center;
		justify-content: flex-end;
		height: 100%;

		&.bubbled {
			border-radius: 15px;
			box-shadow: $inputBoxShadow;
			flex-flow: row nowrap;
			justify-content: space-between;
			padding: 13px 16px;

			.label {
				margin-right: 45px;
				margin-left: 0;
			}
		}

		.label {
			color: $input-color;
			font-size: 14px;
			letter-spacing: .05em;
			font-weight: 600;
			margin-left: 15px;
		}

		.check {
			border: 2px solid $input-color;
			border-radius: 4px;
			background: transparent;
			width: 12px;
			height: 12px;
			transition: .2s ease-in-out;

			&.checked {
				position: relative;

				&::before, &::after {
					left: 65%;
					background: $color-primary;
					box-shadow: $secondaryBoxShadow;
				}

				&::before {
					content: '';
					width: 2px;
					height: 6px;
					position: absolute;
					transform: translate(-3px, 0) rotate(-35deg);
					bottom: calc(50% - 2.5px);
					border-radius: 10px;
				}

				&::after {
					content: '';
					width: 2px;
					height: 12px;
					position: absolute;
					transform: translate(1px, 0) rotate(30deg);
					bottom: calc(50% - 3px);
					border-radius: 3px;
				}
			}
		}
	}
}
</style>
